define('app/views/cities_view',['app/setup', 'app/views/navigation_view'], function(takhfifan, navigationView) {
  takhfifan.citiesView = takhfifan.BaseView.extend({

    template: ( $('#top-menu-template').length > 0 ) ?
      _.template( $('#top-menu-template').html() ) : '',

    initialize: function() {
      var _this = this;
      takhfifan.eventHub.on('navigation:setCity',
        function(city) {
          $('div.footer-newsletter form > input[name="city"]').val(city.id);
          $('div.search-form form > input[name="cityId"]').val(city.id);
          $('.main-bar > .tkh-city-link > .city-val').text(city.name);
          _this.renderTopMenu(city.top_menu);
          $('.tkh-header').find('.menu-toggle').addClass('menu-loaded');
          $.stickyMenu.init();
        }, this);
    },

    events: {
      'click a' : 'saveCityInSession'
    },

    saveCityInSession: function(e){
      if(this.$(e.target).find('.loading').length){
        return;
      }
      var cityId   = $(e.target).data('city-id');
      var cityHref = $(e.target).data('city-href');
      var _this = this;
      this.setLoading($(e.target));
      this.setResetSessionFlag();
      $.post('/ajax/account/savevisitorcategoryinsession' ,
        {
          cityId : cityId
        },
        function(data){
          if(!data || (JSON.parse(data).result != 'saved')){
            _this.removeLoading($(e.target));
            return;
          }
          if($('.tkh-on-map').length){
            window.location.reload()
          }else {
            window.location = cityHref;
          }
        });
    },

    setLoading: function(el){
      el.addClass('loading');
      el.append('<span class="spinner-little"></span>');
    },

    removeLoading: function(el){
      el.removeClass('loading');
      $('.spinner-little').remove();
    },

    renderTopMenu: function (data) {
      $('.tkh-header .tkh-navigation').replaceWith(this.template(data))
    }

  });
});

